import React, { useState, useRef, useEffect } from "react";
import { Form, Row, Col, Button, Modal, Breadcrumb, Container, Navbar } from "react-bootstrap";
import styles from "./Oath.module.css";
import Sidebar from "../../Components/Side Bar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { FiFile } from "react-icons/fi";
import FileIcon from "../../assets/File (1).png"
import { BASE_URL } from "../../Components/API/Api";
import axios from "axios";
import Swal from "sweetalert2";
import SampleImage from "../../assets/sample.png";


const Oath = () => {
  const navigate = useNavigate();
    const location = useLocation();
      const companyData = location.state?.companyData;
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

     const [sidebarOpen, setSidebarOpen] = useState(false);
        const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
        const closeSidebar = () => setSidebarOpen(false);



        const handleDash = () => {
      navigate("/vendor_registration");
    };
        const handleJobs = () => {
      navigate("/vendor_oath");
    };

    const fileInputRef = useRef(null);

  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");

  const allowedTypes = [
  "image/jpeg", // jpg & jpeg
  "image/png",
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
];

const getPreviewUrl = () => {
  if (!companyData?.oath) {
    return SampleImage; // default image
  }

  const fileUrl = companyData.oath;

  if (fileUrl.match(/\.(doc|docx)$/i)) {
    return `https://docs.google.com/gview?url=${encodeURIComponent(
      fileUrl
    )}&embedded=true`;
  }

  // images & pdf will render directly in iframe
  return fileUrl;
};

  const handleFiles = (selectedFiles) => {
    setError("");

    const fileArray = Array.from(selectedFiles);

    if (fileArray.length + files.length > 5) {
      setError("Maximum 5 files allowed.");
      return;
    }

    const validFiles = fileArray.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
  setError("Only JPG, JPEG, PNG, PDF, DOC, DOCX files allowed.");
  return false;
}

      if (file.size > 5 * 1024 * 1024) {
  setError("Each file must not exceed 5MB.");
  return false;
}

      return true;
    });

    setFiles((prev) => [...prev, ...validFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleUploadPersonnel = async () => {
    try {
      if (files.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No File Selected",
          text: "Please select at least one file.",
        });
        return;
      }
  
      const token = localStorage.getItem("userToken");
  
      const formData = new FormData();
  
      files.forEach((file) => {
        formData.append("oath", file);
      });
  
      // Show loader
      Swal.fire({
        title: "Uploading...",
        text: "Please wait while we upload your file.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      const response = await axios.post(
        `${BASE_URL}/company/declaration_of_oath`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      Swal.close();
  
      Swal.fire({
        icon: "success",
        title: "Upload Successful",
        text: response.data?.message || "Personnel uploaded successfully.",
      });
  
      setFiles([]);
  navigate("/vendor_registration");
    } catch (error) {
      Swal.close();
  let errorMsg = "An unexpected error occurred";

  const apiErrors = error?.response?.data?.data;

  if (apiErrors && typeof apiErrors === "object") {
    // get first field error only
    const firstKey = Object.keys(apiErrors)[0];
    if (firstKey && Array.isArray(apiErrors[firstKey])) {
      errorMsg = apiErrors[firstKey][0]; // first message only
    }
  } else if (typeof error?.response?.data?.message === "string") {
    errorMsg = error.response.data.message;
  } else if (error.message) {
    errorMsg = error.message;
  }
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text:
          errorMsg ||
          "Upload failed. Please try again.",
      });
    }
  };

  return (
    <div>
     




    <div className={styles.wrapper}>

  {/* Sidebar */}
        <div className={`${styles.sidenav} ${sidebarOpen ? styles.open : ""}`}>
          <Sidebar show={true} handleClose={closeSidebar} />   {/* always render, control visibility with CSS */}
        </div>

        {/* Mobile overlay (closes sidebar when clicked) */}
        <div
          className={`${styles.mobileOverlay} ${sidebarOpen ? styles.show : ""}`}
          onClick={closeSidebar}
        />

    <div className={styles.card}>
    <div className={styles.welcomeContainer}>
          <button className={styles.hamburger} onClick={toggleSidebar}>
            ☰
          </button>
      <div className={styles.breadcrumbs}>
          <span className={styles.dash} onClick={handleDash} >Vendor Dashboard</span>
          <span className={styles.separator}>&gt;</span>
          <span className={styles.active} onClick={handleJobs}>Oath</span>
        </div>
        </div>
        <hr className={styles.divider} />

      {/* ===== Card Container ===== */}
      <div
    //    className={styles.card}
      >
      

       <div className={styles.container}>
      {/* Header */}
      <div className={styles.topHeader}>
        <h5 className={styles.pageTitle}>Declaration of Oath</h5>


        <div className={styles.btnflex}>  
        <button
          className={styles.addBtn}
          onClick={() => navigate(-1)}
          // onClick={handleJob}
        >
          Back
        </button>
        </div>
      </div>

      

      <hr className={styles.divider} />

      <div style={{ marginTop: 20 }}>
  <p style={{ fontWeight: 600 }}>Preview:</p>

  <iframe
    src={getPreviewUrl()}
    title="Oath Preview"
    width="100%"
    height="500px"
    style={{
      border: "1px solid #ccc",
      borderRadius: 8,
      background: "#f8fafc",
    }}
  />
</div>
<div className={styles.uploadBox} onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} > <img src={FileIcon} className={styles.fileIcon} /> <p style={{color: '#334155', fontWeight: 700}}> Drag and drop your file here or{" "} <span className={styles.browse} onClick={handleBrowseClick} > browse </span> </p> <div className={styles.txtflex}> <small>Supported formats: pdf, doc/docx, jpg, png</small> <div className={styles.limitBox}> Max File Size: 1MB. Max File Upload: 5 </div> </div> <input type="file" multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" ref={fileInputRef} hidden onChange={(e) => handleFiles(e.target.files)} /> {/* File List */} {files.length > 0 && ( <div className={styles.fileList}> {files.map((file, index) => ( <div key={index} className={styles.fileItem}> {file.name} </div> ))} </div> )} </div> {error && <p className={styles.error}>{error}</p>} 
  
     

      

    </div>
    
          
        <div className={styles.btnflexs}>  
          <button
          className={styles.importBtn}
          onClick={() => navigate(-1)}
          
        >
          Cancel
        </button>
        <button
  className={styles.addBtn}
  onClick={handleUploadPersonnel}
>
  Save & Continue
</button>
        
        </div>
        
      </div>

      </div>
    </div>
    </div>
  );
};

export default Oath;
